import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=632417c8&scoped=true&"
import script from "./ChatBody.vue?vue&type=script&lang=js&"
export * from "./ChatBody.vue?vue&type=script&lang=js&"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=632417c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632417c8",
  null
  
)

export default component.exports